import { Injectable } from '@angular/core';
//import { Headers, Http, RequestOptions, RequestOptionsArgs, Response } from '@angular/http';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, BehaviorSubject, defer, from, switchMap, lastValueFrom, filter, take, firstValueFrom } from 'rxjs';
// import 'rxjs/add/operator/catch';
// import 'rxjs/add/observable/of';
// import 'rxjs/add/observable/empty';
// import 'rxjs/add/operator/retry';
import { catchError, map, tap, timeout, debounceTime, flatMap, retry, mergeMap } from 'rxjs/operators';
// import { Flow } from './flows/flow';
// import { PowerApp } from './powerapps/powerapp';
// // import { Maker } from './makers/maker';
// import { AuthResponse } from 'msal';
// import { MsalHelperService } from './msal.service';
// import { Event } from './events/event';

import { addDays, getDate } from '@progress/kendo-date-math';
import { ApolloClient, gql, MutationUpdaterFn, InMemoryCache, ApolloLink, HttpLink, concat, NormalizedCacheObject, Observable as ApolloObservable, from as ApolloFrom, fromPromise, ObservableQuery, OperationVariables } from '@apollo/client/core';
import { onError } from '@apollo/client/link/error';
import { setContext } from '@apollo/client/link/context';
import { loadErrorMessages } from '@apollo/client/dev';
// import { environment } from 'src/environments/environment';
// import { persistCache } from 'apollo-cache-persist';

import { MsalHelperService } from './msal-helper.service';
import { ContextService } from './context.service';
// import { Apollo } from 'apollo-angular';
// import gql from 'graphql-tag';
// import { MutationUpdaterFn } from 'apollo-client';
// import * as localForage from "localforage";

type FilterLeaf = {
  filters?: FilterLeaf[];
  [key: string]: any;
};

type ServicePlan = {
  servicePlanName?: string;
  provisioningStatus?: string;
};

type LicenseAssignment = {
  servicePlans?: ServicePlan[];
};

type NamedEnvironment = {
  name?: string;
  displayName?: string;
  [key: string]: any;
};

export const groupBy = <T extends Record<string, any>>(xs: T[], key: keyof T): Record<string, T[]> => {
  return xs.reduce(function (rv: Record<string, T[]>, x: T) {
    (rv[x[key]] = rv[x[key]] || []).push(x);
    return rv;
  }, {});
};

export const distinct = <T>(value: T, index: number, self: T[]): boolean => {
  return self.indexOf(value) === index;
}

export const flatten = (filter?: FilterLeaf | null): FilterLeaf[] => {
  const filters = (filter || {}).filters;
  if (filters) {
    return filters.reduce((acc: FilterLeaf[], curr: FilterLeaf) => acc.concat(curr.filters ? flatten(curr) : [curr]), []);
  }
  return [];
};

export const pause = (duration: number): Promise<void> => new Promise((res) => setTimeout(res, duration));

export const backoff = <T>(retries: number, fn: () => Promise<T>, delay = 500): Promise<T> =>
  fn().catch(err => retries > 1
    ? pause(delay).then(() => backoff(retries - 1, fn, delay * 2))
    : Promise.reject(err));

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  public serviceStatus$ = new BehaviorSubject("");
  private _host = '';

  public overview$ = new BehaviorSubject(null);
  public overviewRun$ = new BehaviorSubject(null);

  public maker$ = new BehaviorSubject<any[]>([]);
  public flow$ = new BehaviorSubject<any[] | null>(null);
  public environment$ = new BehaviorSubject<NamedEnvironment[]>([]);
  public app$ = new BehaviorSubject<any[]>([]);
  public run$ = new BehaviorSubject<any[] | null>(null);
  public tenant$ = new BehaviorSubject<any[]>([]);
  public complianceList$ = new BehaviorSubject<any[]>([]);
  public dataSource$ = new BehaviorSubject<any[]>([]);

  public users$ = new BehaviorSubject<any[]>([]);
  //public user$ = new BehaviorSubject(null);
  public license$ = new BehaviorSubject('');
  private watchFlowsPromise: Promise<any[]> | null = null;

  private csvServer = 'https://prod.flowstudio.app/csv';

  private apollo!: ApolloClient<NormalizedCacheObject>;

  constructor(
    private httpClient: HttpClient,
    private msalHelperService: MsalHelperService,
    private contextService: ContextService
  ) {

    contextService.canUseGraphQL$.pipe(
      filter(can => can === true),
      take(1)
    ).subscribe(() => {
      this.initApollo();
      this.queryMakers();
      this.queryEnvs();
    })


    // this.msalHelperService.user$.pipe(
    //   mergeMap((user)=>{
    //     return from(this.queryUsers().then((users)=>{
    //       const user1 = users.find((u)=>u.unique_name == user.userName);

    //       this.user$.next({
    //         ...user,
    //         ...user1
    //       })

    //       const {license} = user1;
    //       return license;  
    //     }));
    //   })
    // ).subscribe((license)=>{
    //   this.license$.next(license);
    // });
  }

  baseEntity =
    `description
  critical
  monitor
  
  businessImpact
  businessJustification
  businessValue
  ownerTeam
  ownerBusinessUnit
  supportSolution
  supportGroup
  supportEmail
  supportDocumentation
  supportValue

  supportComplexity

  custom
  `;

  flowsQuery = `
    flows {
      RowKey
      name
      displayName

      actionsCount
      tags

      state
      sharingType
      referencedResources
      critical
      monitor

      triggerType
      triggerKind
      triggers

      lastModifiedTime
      
      createdTime
      createdById
      workflowEntityId   
      ref_createdBy {
        displayName
        deleted
      }   
    }
  `;

  private async initApollo(): Promise<ApolloClient<NormalizedCacheObject>> {

    if (this.apollo) {
      return this.apollo;
    }

    if (window.location.hostname == 'localhost') {
      this._host = 'https://flow-studio-clarity.azurewebsites.net'
    }
    let graphServer = 'https://prod.flowstudio.app/graphql';
    let devGraphServer = 'https://dev.flowstudio.app/graphql';
    // Legacy dev.powerclarity.app references removed — use api.flowstudio.app
    switch(window.location.hostname) {
      case 'dev.flowstudio.app': 
        graphServer = devGraphServer;
        this.csvServer = `https://dev.flowstudio.app/csv`
        break;
      case 'localhost':
        graphServer =  `/api/graphql`;
        devGraphServer = `/api/graphql`;
        this.csvServer = `/api/csv`
        break;
      default:
        devGraphServer = graphServer;
        this.csvServer = `https://prod.flowstudio.app/csv`
        break;
    }

    let cache = new InMemoryCache({
      // dataIdFromObject: (object) => object['RowKey'] || null
      typePolicies: {
        Flow: {
          keyFields: ['RowKey'],
          fields: {
            owners: {
              read: (parent, { readField }) => {
                const _owners = JSON.parse(parent || '[]');
                if (_owners.length > 0) {
                  return _owners;
                }

                const createdById = readField('createdById');
                return [
                  {
                    "name": createdById,
                    "permissionType": "Principal",
                    "principalId": createdById,
                    "principalType": "User"
                  }
                ];
              }
            },
            createdByDisplayName: {
              read: (parent, { readField }) => {
                const ref_createdBy: any = readField('ref_createdBy');
                return ref_createdBy?.displayName;
              }
            }
            // ref_createdBy: {
            //   read: (parent, {readField})=>{
            //     //const ref_createdBy = readField('ref_createdBy');
            //     const createdById = readField('createdById');
            //     if (parent?.ref_createdBy?.displayName == null) {
            //       const maker = this.maker$.getValue().find( (maker)=>maker.RowKey == createdById);
            //       if (maker) {
            //         //const { displayName, deleted, ...rest } = <any>ref_createdBy;
            //         return ({
            //           displayName: `${maker?.displayName || maker?.RowKey}${maker?.deleted ? ' (disabled)':''}`,
            //           deleted: maker?.deleted,
            //           //...rest
            //         });
            //       }
            //     }
            //     return ref_createdBy;
            //   }
            // }  
          }
        },
        Maker: {
          fields: {
            flowLicenses: {
              read: (_, { readField }) => {

                const flowLicenses: string[] = [];
                const licenses = readField('licenses');
                if (licenses && typeof (licenses) == "string") {
                  (JSON.parse(licenses) as LicenseAssignment[]).forEach((l: LicenseAssignment) => {
                    (l['servicePlans'] || []).forEach((sp: ServicePlan) => {
                      const servicePlanName = sp['servicePlanName'];
                      if (servicePlanName?.includes('FLOW') && sp['provisioningStatus'] === "Success" && !flowLicenses.includes(servicePlanName)) {
                        flowLicenses.push(servicePlanName);
                      }
                    });
                  });
                }
                return flowLicenses;
              }
            },
            powerAppLicenses: {
              read: (_, { readField }) => {

                const powerAppLicenses: string[] = [];
                const licenses = readField('licenses');
                if (licenses && typeof (licenses) == "string") {
                  (JSON.parse(licenses) as LicenseAssignment[]).forEach((l: LicenseAssignment) => {
                    (l['servicePlans'] || []).forEach((sp: ServicePlan) => {
                      const servicePlanName = sp['servicePlanName'];
                      if (servicePlanName?.includes('POWERAPPS') && sp['provisioningStatus'] === "Success" && !powerAppLicenses.includes(servicePlanName)) {
                        powerAppLicenses.push(servicePlanName);
                      }
                    });
                  });
                }
                return powerAppLicenses;
              }
            },
            displayName: {
              read: (parent, { readField }) => {
                //let maker = Object.assign({}, m);
                let displayName = parent;
                if (displayName == 'null null' /* bad scan error */) {
                  displayName = null;
                }
                if (displayName) {
                  return displayName;
                }

                const givenName = readField('givenName');
                const surname = readField('surname');

                if (givenName || surname) {
                  displayName = [givenName, surname].filter(n => !!n).join(' ');
                }
                if (!displayName) {
                  // user is deleted, we only know a user guid
                  displayName = readField('RowKey');
                }
                return displayName;
              }
            }
          }
        },
        Run: {
          fields: {
            environmentName: {
              read: (_, { readField }) => {
                const environment = readField('environment');
                return this.environment$.getValue().find((env) => env.name == environment)?.displayName;
              }
            }
          }
        },
        Account: {
          keyFields: ['RowKey'],
        },
        Rule: {
          keyFields: ['RowKey'],
        }
      }
    });

    // persistCache({
    //   cache: cache,
    //   storage: window.localStorage,
    //   maxSize: 5200000
    // } as any);

    const setContextLink = setContext((_, { headers, ...rest }) => {
      return this.msalHelperService.getAccessTokenSilent$(['https://service.flow.microsoft.com//Flows.Manage.All']).toPromise()
        .then((result) => {
          if (!result?.accessToken) {
            return { headers, ...rest };
          }
          const token = result.accessToken;
          // msalHelperService.getUser(true)
          // .then( (response: AuthResponse)=>{
          //   return response.accessToken;
          // })
          // .then( (token:string)=>{
          //const token = this.msalHelperService.getCachedTokenInternal(['https://service.flow.microsoft.com//Flows.Manage.All']);
          //let headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
          let newHeaders = {
            ...headers,
            authorization: `Bearer ${token}`,
            'x-authorization': `Bearer ${token}`,
          };
          if (window.localStorage.getItem('xx-tt')) {
            newHeaders['xx-tt'] = window.localStorage.getItem('xx-tt');
          }
          return {
            ...rest,
            headers: newHeaders
          };
        }, () => {
          return { headers, ...rest };
        });
    }
    );

    loadErrorMessages();

    this.apollo = new ApolloClient({
      cache: cache,
      link: ApolloLink.from([
        onError(({ graphQLErrors, networkError, operation, forward }) => {
          if (networkError) {
            operation.setContext({ uri: devGraphServer });
            // Retry the request, returning the new observable
            return forward(operation);
          }
        }),
        setContextLink,
        new HttpLink({
          uri: graphServer,
        }),
      ]),

      // new ApolloLink((operation, forward) => {
      //   // add the authorization to the headers
      //   return msalService.getToken(true).then( (token:string)=>{
      //     let headers = new HttpHeaders() //.set('Authorization', `Bearer ${token}` /*localStorage.getItem('token')*/ || null)
      //     if (window.localStorage.getItem('xx-tt')){
      //       headers = headers.set('xx-tt', window.localStorage.getItem('xx-tt'));
      //     }
      //     operation.setContext({
      //       headers: headers
      //     });          
      //     return forward(operation);      
      //   });
      // }),
      //          new ApolloLink((operation, forward) => {
      //             operation.setContext({uri: graphServer});
      //             return forward(operation).map((response) => {
      //               if (response.errors) {
      //                 // Handle errors (e.g., server down)
      //                 console.error('Primary server error:', response.errors);
      //                 // Switch to the fallback server
      //                 operation.setContext({ uri: devGraphServer });
      //                 return forward(operation).map((response)=> response);
      //               }
      //               return response;
      //             });
      //           })
      assumeImmutableResults: true
    });

    return this.apollo;
  }

  public queryOverviewRuns(startTime: Date | null = null) {

    if (startTime == null) {
      startTime = addDays(new Date(), -31);
    }

    const pOverview = this.apollo
      .query({
        query: gql`
        query overview($startTime: String) {
          summary(startTime:$startTime) {
            runs
            fails
            week
          }
        }
        `,
        variables: {
          'startTime': startTime.toISOString()
        }
      });
    pOverview.then((result) => {
      if (result.errors == null) {
        this.overviewRun$.next(result.data);
      }
    })

    return pOverview;
  }

  public queryOverview(startTime: Date | null = null) {

    if (startTime == null) {
      startTime = addDays(new Date(), -31);
    }

    const fn = () => this.apollo
      .query({
        query: gql`
        {
          environments {
            RowKey
            name
            displayName
            sku
            type

            createdTime
            createdByDisplayName
            connectedGroups
          }
          ${this.flowsQuery}
          powerapps {
            name
            displayName

            isFeaturedApp
            sharedUsersCount
            sharedGroupsCount

            createdTime
            ownerId
            ownerName
            appPlanClassification
          }
          makers {
            uid
            displayName

            firstFlowCreatedTime
            lastFlowCreatedTime
            ownerFlowCount

            firstPowerAppCreatedTime
            lastPowerAppCreatedTime
            ownerAppCount
            
            deleted
          }
          connections {
            displayName
            apiId
            connected
            gateway
            createdTime
            lastModifiedTime
          }
        }
      `,
        // variables: {
        //   'startTime': startTime.toISOString()
        // }
      });
    const pOverview = backoff(3, fn);

    pOverview.then((result: any) => {
      if (result.errors == null) {
        this.overview$.next(result.data);
      }
    })

    return pOverview;
  }

  public queryOverviewStore() {
    const fn = () => this.apollo
      .query({
        query: gql`
        query overviewStore {
          stores {
            RowKey
          }
        }
      `
      });

    return backoff(3, fn);
  }

  public queryOverviewAccount() {
    return this.apollo
      .query({
        query: gql`
          query overviewAccount {
            accounts {
              RowKey
              name
              unique_name
              oid
              expires_at
              error
              pa_error
            }
          }
        `
      })
  }

  public async watchFlows() {
    if (this.watchFlowsPromise) {
      return this.watchFlowsPromise;
    }

    this.watchFlowsPromise = this.watchFlowsInternal().finally(() => {
      this.watchFlowsPromise = null;
    });

    return this.watchFlowsPromise;
  }

  private async watchFlowsInternal() {
    const current = this.flow$.value || [];
    console.log('[ApiService] watchFlows skipped: /api/flows is disabled for app flow loading');
    this.flow$.next(current);
    return current;
  }

  public queryFlow(id: string) {
    return this.apollo
      .query({
        query: gql`
    {
      flow(name:"${id}") {
        RowKey
        name
        displayName
        
        ${this.baseEntity}

        actions
        actionsCount
        connections

        state
        sharingType
        referencedResources
        critical        

        triggerType
        triggers
        triggerKind
        triggerUrl

        workflowEntityId

        ref_environment {
          name
          displayName
        }
        ref_owners {
          RowKey
          displayName
          mail
        }
        ref_createdBy {
          RowKey
          displayName
          mail
        }
        ref_connections {
          name
          displayName
          apiId
          iconUri
        }

        runEstimates
        runFails
        runTotal
        runLast

        throttlingData

        rule_notify_onfail
        rule_notify_onmissingdays
        rule_notify_email
      }
    }
      `
      });
  }

  public mutateFlow(key: string, model: any, update: MutationUpdaterFn<any>) {
    return this.apollo.mutate({
      mutation: gql`
        mutation updateFlow($key:ID!, $flow: FlowInput) {
          updateFlow(key: $key, flow: $flow) {
            RowKey
            name
            displayName
            monitor

            rule_notify_onfail
            rule_notify_onmissingdays
            rule_notify_email
          }
        }`,
      variables: {
        key: key,
        flow: model
      },
      update: update
    })
  }

  public mutateFlowState(key: string, state: string, update: MutationUpdaterFn<any>) {
    return this.apollo.mutate({
      mutation: gql`
        mutation updateFlowState($key: ID!, $state: String!)
        {
          updateFlowState(key: $key, state: $state) {
            name
            displayName
            
            ${this.baseEntity}

            actions
            actionsCount
            connections

            state
            sharingType
            referencedResources
            critical

            triggerType
            triggers
            triggerKind
            triggerUrl

            workflowEntityId

            ref_environment {
              name
              displayName
            }
            ref_owners {
              RowKey
              displayName
              mail
            }
            ref_createdBy {
              RowKey
              displayName
              mail
            }
            ref_connections {
              name
              displayName
              apiId
              iconUri
            }

            runEstimates
            runFails
            runTotal
            runLast

            runError
            runPeriodTotal
            runPeriodSuccess
            runPeriodSuccessRate
            runPeriodFails
            runPeriodFailRate
            runPeriodRunning
            runPeriodRunningRate
            runPeriodDurationMin
            runPeriodDurationMax
            runPeriodDurationAverage
            runSummaryTotal
            runSummarySuccessRate
            runSummaryFailRate
            runSummaryDurationCount
            runSummaryDurationSum
            runSummaryDurationAverage


          }
        }`,
      variables: {
        key: key,
        state: state
      },
      update: update,
    })
  }

  public mutateFlowOwners(key: string, owners: string[] , update: MutationUpdaterFn<any>) {
    return this.apollo.mutate({
      mutation: gql`
        mutation updateFlowOwner($key: ID!, $owners: [String]!)
        {
          updateFlowOwner(key: $key, owners: $owners) {
            name
            displayName
            
            ${this.baseEntity}

            actions
            actionsCount
            connections

            state
            sharingType
            referencedResources
            critical

            triggerType
            triggers
            triggerKind
            triggerUrl

            workflowEntityId

            ref_environment {
              name
              displayName
            }
            ref_owners {
              RowKey
              displayName
              mail
            }
            ref_createdBy {
              RowKey
              displayName
              mail
            }
            ref_connections {
              name
              displayName
              apiId
              iconUri
            }

            runEstimates
            runFails
            runTotal
            runLast
          }
        }`,
      variables: {
        key: key,
        owners: owners
      },
      update: update,
    })
  }

  public mutateComplianceList(key: string, listType: string, listValue: string , update: MutationUpdaterFn<any>) {
    return this.apollo.mutate({
      mutation: gql`
        mutation updateComplianceList($key: ID!, $listType: String!, $listValue: String!)
        {
          updateComplianceList(key: $key, listType: $listType, listValue: $listValue) {
            complianceListAllow
            complianceListBlock
            primaryUser
            
          }
        }`,
      variables: {
        key: key,
        listType: listType,
        listValue: listValue

      },
      update: update,
    })
  }

  public mutateRule(RowKey: string, webhook: string, frequency: string, startTime: string, type: string, properties: string, disabled: boolean, IsDelete: boolean, update: MutationUpdaterFn<any>) {
    return this.apollo.mutate({
      mutation: gql`
        mutation upsertRule($RowKey: String!, $webhook: String, $frequency: String, $startTime: String, $type: String, $properties: String, $disabled: Boolean, $IsDelete: Boolean) {
          upsertRule(RowKey: $RowKey, webhook: $webhook, frequency: $frequency, startTime: $startTime, type: $type, properties: $properties, disabled: $disabled, IsDelete: $IsDelete) {
            RowKey,
            webhook,
            frequency,
            startTime,
            type
            properties
            disabled
          }
        }`,
      variables: {
        RowKey,
        webhook,
        frequency,
        startTime,
        type,
        properties,
        disabled,
        IsDelete
      },
      update: update,
      refetchQueries: [{query: gql`
        {
          rules {
            RowKey
            webhook
            startTime
            frequency
            type
            properties
            disabled
          }
        }
        `}]
    })
  }

  public queryApps() {
    return this.apollo
      .query({
        query: gql`
      {
        ${this.flowsQuery}
        powerapps {
          name
          displayName
          createdTime
          ownerId
          ownerName
          lastModifiedById   
          lastModifiedTime
          environmentName
          ref_environment {
            name
            displayName
          }        
          sharedUsersCount
          sharedGroupsCount
          tags
          isFeaturedApp
          isHeroApp
          appVersion
          backgroundColor
          backgroundImageUri

          databaseReferences
          sharepointFormUrl   
          
          appType
          appPlanClassification
          connectionReferences
        }
      }
      `
      }).then((result)=>{
        const apps = result.data.powerapps.map((app: any)=>{

          if (app.databaseReferences || app.sharepointFormUrl) {
            // debugger
          }
          return app;
        });
        this.app$.next(apps);
        return apps;
      });
  }

  public queryMakers() {
    return this.apollo
      .query({
        query: gql`
      {
        makers {
          displayName
          givenName
          surname
          mail
          jobTitle
          officeLocation
          deleted
          RowKey

          firstFlow
          firstFlowCreatedTime
          firstPowerApp
          firstPowerAppCreatedTime

          ownerFlowCount
          ownerAppCount

          lastPowerAppCreatedTime
          lastFlowCreatedTime
          
          licenses
          createdDateTime

          flowLicenses @client
          powerAppLicenses @client
        }
      }
      `
      }).then((result)=>{
        const makers = result.data.makers; /*.map( (m)=>{

          let maker = Object.assign({}, m);
          if (maker.displayName == 'null null' ) {
            maker.displayName = null;
          }
          if (!maker.displayName) {
            if (maker.givenName || maker.surname) {
              maker.displayName = [maker.givenName, maker.surname].filter( n=>!!n).join(' ');
            }
          }
          if (!maker.displayName) {
            maker.displayName = maker.RowKey;
          }
          // let flowLicenses = [];
          // let powerAppLicenses = [];
          // if (m.licenses && typeof(m.licenses) == "string"){
          //   const licenses = JSON.parse(m.licenses);
          //   licenses.forEach(l=>{
          //     l['servicePlans'].forEach(sp => {
          //         if(sp['servicePlanName'].includes('FLOW') && sp['provisioningStatus'] === "Success" && !flowLicenses.includes(sp['servicePlanName'])) flowLicenses.push(sp['servicePlanName']);
          //         if(sp['servicePlanName'].includes('POWERAPPS') && sp['provisioningStatus'] === "Success" && !powerAppLicenses.includes(sp['servicePlanName'])) powerAppLicenses.push(sp['servicePlanName']);
          //     });
          //   });


          //   Object.assign(m, {flowLicenses, powerAppLicenses});
          // }  
          return maker;
        })
        // flowLicenses: flowLicenses,
        // powerAppLicenses: powerAppLicenses,
        */

        this.maker$.next(makers);
        return makers;
      });
  }

  public queryUsers() {
    return this.apollo
      .query({
        query: gql`
      {
        users {
          PartitionKey
          RowKey
          name
          unique_name
          oid
          license
          key
          keyCreatedTime
          keyExpiryTime
        }
      }
      `
      }).then((result)=>{
        const users = result.data.users; 

        this.users$.next(users);
        return users;
      });
  }

  public queryComplianceList() {
    return this.apollo
      .query({
        query: gql`
      {
        complianceList {
          RowKey
          complianceListAllow
          complianceListBlock
          primaryUser
        }
      }
      `
      }).then((result)=>{
        const compList = result.data.complianceList; 

        this.complianceList$.next(compList);
        return compList;
      });
  }

  public queryDataSources() {
    return this.apollo
      .query({
        query: gql`
      {
        datasources {
          RowKey
          createdDateTime
          source
          status
          type
          updatedDateTime
        }
      }
      `
      }).then((result)=>{
        const ds = result.data.datasource; 

        this.dataSource$.next(ds);
        return ds;
      });
  }

  public queryDataSource(id: string) {
    return this.apollo
      .query({
        query: gql`
        {
          datasource(RowKey:"${id}") {
            RowKey
            createdDateTime
            source
            status
            type
            updatedDateTime
          }
        }
      `
      });
  }

  public watchFlowDetailsByMaker({ RowKey }: { RowKey: String }) {
    return this.apollo
      .watchQuery({
        query: gql`
      {
        lastFlowByMaker(makerName:"${RowKey}") {
          RowKey
          name
          createdTime
          environmentName
          displayName
          lastModifiedTime
          isFlow
        }
        lastAppByMaker(makerName:"${RowKey}") {
          RowKey
          name
          createdTime
          environmentName
          displayName
          lastModifiedTime
          isFlow
        }
      }
      `
      });
  }

  public queryEnvs() {
    return this.apollo
      .query({
        query: gql`
      {
        environments {
          RowKey
          name
          displayName
          sku
          type
          linkedEnvironmentMetadata
          isDefault

          azureRegionHint

          createdTime
          createdByDisplayName
          connectedGroups
        }
      }
      `
      }).then((result)=>{
        const envs = result.data.environments;
        this.environment$.next(envs);
        return envs;
      });
  }

  public queryTenants() {
    return this.apollo
      .query({
        query: gql`
      {
        tenants {
          RowKey
          complianceListAllow
          complianceListBlock
          primaryUser
        }
      }
      `
      }).then((result)=>{
        const tenants = result.data.tenants;
        this.tenant$.next(tenants);
        return tenants;
      });
  }

  public queryTenant(id: string) {
    return this.apollo
      .query({
        query: gql`
        {
          tenant(RowKey:"${id}") {
            complianceListAllow
              complianceListBlock
              primaryUser

          }
        }
      `
      });
  }

  public watchReports() {
    return this.apollo
      .watchQuery({
        query: gql`
      {
        reports {
          name
          uri
          lastModified
        }
      }
      `
      });
  }

  public watchConnections() {
    return this.apollo
      .watchQuery({
        query: gql`
      {
        connections {
          displayName
          apiId
          connected
          gateway
        }
      }
      `
      });
  }

  public watchRuns(days = -7) {
    let start = getDate(new Date());
    let end = getDate(new Date());
    if (days > -1) {
      days == -1;
    }
    start = addDays(start, days);

    return this.apollo
      .query({
        query: gql`
      {
        runs(startTime:"${start.toISOString()}") {
          startTime
          endTime
          status
          triggerName
          failedActions
          remediation

          flowDisplayName
          environment
          environmentName @client
          flowName
          name          
        }
#        environments {
#          name
#          displayName
#        }
      }
      `
      }).then( (result)=> {
        // const envs = result.data.environments;
        // const runs = result.data.runs.map( (run)=>{
        //   // run.environmentName = envs.find( (env)=>env.name == run.environment)?.displayName;
        //   return new Event(run);
        // });
        const runs = result.data.runs;
        this.run$.next(runs);
        return {
          start,
          end,
          runs
        };
      });
    //         runs(startTime:String, status:[String]): [Run]

  }

  public async queryConfigurations() {

    await this.initApollo();

    return this.apollo
    ?.query({
      query: gql`
    {
      accounts {
        RowKey
        name
        unique_name
        oid
        expires_at
        expires_at_cds
        pa_expires_at
        o_expires_at
        error
      }
      rules {
        RowKey
        webhook
        startTime
        frequency
        type
        properties
        disabled
      }
    }
    `
    });
    // Avoids calling query if service is null
  }

  public async watchConfigurations() {

    await this.initApollo();
    //
    return this.apollo
    ?.watchQuery({
      query: gql`
    {
      accounts {
        RowKey
        name
        unique_name
        oid
        expires_at
        expires_at_cds
        pa_expires_at
        o_expires_at
        error
      }
      rules {
        RowKey
        webhook
        startTime
        frequency
        type
        properties
        disabled
      }
    }
    `,
    fetchPolicy: 'cache-and-network'
    });
    // Avoids calling query if service is null
  }

  public queryRules() {
    return this.apollo
      .query({
        query: gql`
      {
        rules {
          RowKey
          webhook
        }
      }
      `
    }).then(result=>{
      return result.data.rules;
    });
  }

  public queryScans() {
    return this.apollo
      .query({
        query: gql`
      {
        scans {
          account
          RowKey
          environment
          admin_count
          count
          start
          run
          type
        }
      }
      `,
      fetchPolicy: "network-only"
    }).then(result=>{
      const scans : any[] = (result.data.scans || []);

      if (scans.length == 0) {
        return null;
      }

      let stats = scans.reduce((arr:any[], v)=>{

        const { RowKey, admin_count, type, count, start, run, account } = v;
        const p0 = arr.find((p1)=>p1.account == account);
        let p = p0 || { account };

        switch(type){
          case "apps":
            p.apps = (p.apps || 0) + admin_count
            break;
          case "flows":
            p.flows = (p.flows || 0) + admin_count
            break;
          case "environments":
            p.envs = (p.envs || 0) + admin_count
            break;
        }

        if (p0 == null){
          arr.push(p);
        }
        return arr;
      }, []);

      stats.forEach((e)=>{
        // find current batch only.
        let batch = scans.filter((r)=>r.account == e.account);

        // always the first
        let [min] = batch.filter((r)=>r.type=="environments");
        // let min = scans.reduce((p,v)=>{
        //   return p['start'] < v['start'] ? p : v;
        // });
        let max = batch.reduce((p,v)=>{
          return p['start'] > v['start'] ? p : v;
        }, {});
        if (min) {
          e.start = min.start;
        }
        if (max) {
          e.end = max.start;
          if (max.type == "completed") {
            e.ended = true;
          }
          e.maxType = max.type;
        }
    

      })



      // if (stats.maxType != "completed") {
      //   // change time to current time
      //   //stats.end = (new Date()).toISOString();
      // }
      // if (stats.start && stats.end) {

      //   // const start = new Date(stats.start).valueOf();
      //   // const end = new Date(stats.end).valueOf();

      //   // const diffInMs = Math.abs(end - start);
      //   // let diffInMins = Math.floor(diffInMs / 1000 / 60);
      //   // const diffInSecs = Math.floor((diffInMs / 1000) % 60);

      //   // // strange bug in start date??
      //   // if (diffInMins > 60) {
      //   //   //diffInMins -= 60;
      //   // }
         
      //   // stats.timespan = `${diffInMins} minutes and ${diffInSecs} seconds`;
      // }

      return stats;
    });
  }

  public queryScansHttp(): Promise<any[] | null> {
    return this.msalHelperService.getAccessTokenSilent$(['https://service.flow.microsoft.com//Flows.Manage.All']).toPromise()
      .then((result) => {
        const headers = new HttpHeaders({
          'Content-Type': 'application/json',
          ...(result?.accessToken ? { 'x-authorization': `Bearer ${result.accessToken}` } : {})
        });
        return this.httpClient.get<{ scans: any[] | null }>('/api/teams/scans', { headers }).toPromise();
      })
      .then((response) => response?.scans ?? null);
  }

  public requestTrial(request: any) {
    return this.httpClient.post(`https://powerclarity.app/request/trial`, request);
  }

  public ready(email: string) {
    let readyUrl= `https://powerclarity.app/server/ready`;
    // if (window.location.hostname == 'localhost') {
    //   readyUrl = 'http://localhost:7071/api/Ready';
    // }
    return this.httpClient.post(`${readyUrl}?email=${email}`, null);
  }

  public saveAs(blob: Blob, fileName: string) {
    const link = document.createElement('a');
    link.download = fileName;
    link.href = window.URL.createObjectURL(blob);
    link.click();
    window.URL.revokeObjectURL(link.href);
  }

  public downloadCsv(table: string) {

    return this.msalHelperService.getAccessTokenSilent$(['https://service.flow.microsoft.com//Flows.Manage.All']).toPromise()
    .then((result) => {
      if (!result?.accessToken) {
        return;
      }
      const token = result.accessToken
      const headers = new HttpHeaders({
        'Accept':'text/csv',
        'Authorization': `Bearer ${token}`,
      });

      this.httpClient.get(`${this.csvServer}?table=${table}`, { headers, responseType: 'blob'}).subscribe(
        (response:Blob)=>{
          //const file = new Blob([response.body], { type: response.type });
          this.saveAs(response, `${table}.csv`);
        }
      )
    });

  }

}
